import { render, staticRenderFns } from "./f360Pagination.vue?vue&type=template&id=a2a563ba&scoped=true"
import script from "./f360Pagination.vue?vue&type=script&lang=js"
export * from "./f360Pagination.vue?vue&type=script&lang=js"
import style0 from "./f360Pagination.vue?vue&type=style&index=0&id=a2a563ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a563ba",
  null
  
)

export default component.exports